export const FLT = 'flt'
export const MMB = 'mmb'
export const CKI = 'cki'
export const CSS = 'css'

export const ripTypes = [FLT, MMB, CKI] as const

export type PageType = typeof FLT | typeof MMB | typeof CKI | typeof CSS
